import { Box, Typography } from "@mui/material";
import { LongText, SpaceBetweenBox } from "components/GeneralStyled";
import NumberFormats from "components/NumberFormats";

function WithdrawConfirmationResult({ withdrawResult }) {
  return (
    <>
      <Box>
        {withdrawResult?.coinName ? (
          <SpaceBetweenBox>
            <Typography color="text.secondary" variant="h6">
              Coin
            </Typography>
            <Typography color="text.main" variant="h6" textAlign="end">
              {withdrawResult?.coinName}
            </Typography>
          </SpaceBetweenBox>
        ) : (
          ""
        )}

        {withdrawResult?.amount ? (
          <SpaceBetweenBox>
            <Typography component="span" color="text.secondary" variant="h6">
              Amount
            </Typography>

            <Typography
              component="span"
              color="text.main"
              variant="h6"
              textAlign="end"
            >
              <NumberFormats value={withdrawResult?.amount} />{" "}
              {withdrawResult?.coinName}
            </Typography>
          </SpaceBetweenBox>
        ) : (
          ""
        )}

        {withdrawResult?.fee ? (
          <SpaceBetweenBox>
            <Typography color="text.secondary" variant="h6">
              Fee
            </Typography>

            <Typography color="text.main" variant="h6" textAlign="end">
              {withdrawResult?.fee} {withdrawResult?.coinName}
            </Typography>
          </SpaceBetweenBox>
        ) : (
          ""
        )}

        {withdrawResult?.userSide ? (
          <SpaceBetweenBox>
            <Typography color="text.secondary" variant="h6">
              Username side
            </Typography>

            <Typography color="text.main" variant="h6" textAlign="end">
              {withdrawResult?.userSide}
            </Typography>
          </SpaceBetweenBox>
        ) : (
          ""
        )}

        {withdrawResult?.address ? (
          <SpaceBetweenBox>
            <Typography color="text.secondary" variant="h6">
              Address
            </Typography>

            <LongText color="text.main" variant="h6" textAlign="end">
              {withdrawResult?.address}
            </LongText>
          </SpaceBetweenBox>
        ) : (
          ""
        )}

        {withdrawResult?.type ? (
          <SpaceBetweenBox>
            <Typography color="text.secondary" variant="h6">
              Type
            </Typography>

            <Typography color="text.main" variant="h6" textAlign="end">
              {withdrawResult?.type}
            </Typography>
          </SpaceBetweenBox>
        ) : (
          ""
        )}

        {withdrawResult?.walletType ? (
          <SpaceBetweenBox>
            <Typography color="text.secondary" variant="h6">
              Wallet Type
            </Typography>

            <Typography color="text.main" variant="h6" textAlign="end">
              {withdrawResult?.walletType}
            </Typography>
          </SpaceBetweenBox>
        ) : (
          ""
        )}

        {withdrawResult?.network && withdrawResult?.network !== "Toman" ? (
          <SpaceBetweenBox>
            <Typography color="text.secondary" variant="h6">
              Network
            </Typography>

            <Typography color="text.main" variant="h6" textAlign="end">
              {withdrawResult?.network}
            </Typography>
          </SpaceBetweenBox>
        ) : (
          ""
        )}

        {withdrawResult?.side ? (
          <SpaceBetweenBox>
            <Typography color="text.secondary" variant="h6">
              Side
            </Typography>

            <Typography color="text.main" variant="h6" textAlign="end">
              {withdrawResult?.side}
            </Typography>
          </SpaceBetweenBox>
        ) : (
          ""
        )}

        <SpaceBetweenBox>
          <Typography color="text.secondary" variant="h6">
            Date Time
          </Typography>

          <Typography color="text.main" variant="h6" textAlign="end">
            {withdrawResult?.date} {withdrawResult?.time}
          </Typography>
        </SpaceBetweenBox>
      </Box>
    </>
  );
}

export default WithdrawConfirmationResult;
